import React from "react";
import "./HomeApp.css";
import {CoreAppResponse} from "../logic/APITypes";
import {useIntl} from "react-intl";
import {Link} from "react-router-dom";
import Image from "./Image";
import externalLink from "../resources/icons/external-link.svg";

const HomeApp = ({
  id,
  name,
  logo,
  app_urls,
  detailsLink,
  isCoreApp,
}: CoreAppResponse & {detailsLink: string; isCoreApp?: boolean}) => {
  const {formatMessage} = useIntl();

  return (
    <div className={"homeApp" + (isCoreApp ? " homeApp--core" : "")}>
      <Image src={logo} alt={name} width={96} height={96} />
      {isCoreApp && <div className="homeApp__coreName">{name}</div>}
      <div className="homeApp__links" key={id}>
        <Link
          to={detailsLink}
          state={{from: "home"}}
          className="homeApp__link"
          aria-label={formatMessage(
            {id: "general.link.ariaLabel.internal"},
            {
              name: name,
            },
          )}
        />
        {app_urls.map((appUrl) => (
          <Link
            key={id + "-" + appUrl.name}
            className="linkButton"
            to={appUrl.url}
            target="_blank"
            rel="noreferrer"
            aria-label={formatMessage(
              {id: "general.link.ariaLabel.external"},
              {name: appUrl.name},
            )}
          >
            {appUrl.name}
            <img src={externalLink} alt="" width={12} height={12} />
          </Link>
        ))}
      </div>
    </div>
  );
};

export {HomeApp};
